module.exports = __webpack_public_path__ + "static/img/mask-2.22a2e79.png";


//////////////////
// WEBPACK FOOTER
// ./static/ugc/creation/filter/mask-2.png
// module id = z6Ex
// module chunks = 1